function renderHelixLoaderTemplate(label) {
  const labelText = String(label || 'Loading graph');
  const ariaLabel = labelText.replace(/"/g, '&quot;');
  const labelHtml = labelText
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  return `<div class="helix-loading-indicator" role="status" aria-live="polite" aria-label="${ariaLabel}">
    <div class="helix-wrapper">
      <svg class="helix-loader" viewBox="-4 0 108 100" width="96" height="96" focusable="false" aria-hidden="true">
        <path class="strand-segment strand-segment--primary" d="M 0,50 Q 25,0 50,50 Q 75,100 100,50" fill="none"></path>
        <path class="strand-segment strand-segment--secondary" d="M 0,50 Q 25,100 50,50 Q 75,0 100,50" fill="none"></path>
        <circle class="node node--start" cx="0" cy="50" r="3"></circle>
        <circle class="node node--middle" cx="50" cy="50" r="3"></circle>
        <circle class="node node--end" cx="100" cy="50" r="3"></circle>
      </svg>
    </div>
    <div class="helix-loading-label">${labelHtml}</div>
    <div class="helix-loading-bar" aria-hidden="true"><span class="helix-loading-bar__fill"></span></div>
  </div>`;
}

function renderChatMessageTemplate(queryValue, editId) {
  return `<div style="float: right">
    <i class="delete-chat-message-icon chat-message-icon material-icons mdl-list__item-icon"
                   style="height: 30px;
                          width: 43px;
        font-size: 32px;
        color: #9028d5;" data-id="${editId}">delete</i>
    <i class="refresh-chat-message-icon chat-message-icon material-icons mdl-list__item-icon"
                   style="height: 30px;
                          width: 43px;
        font-size: 32px;
        color: #9028d5;" data-id="${editId}">refresh</i>
    <i class="share-chat-message-icon chat-message-icon material-icons mdl-list__item-icon"
                   style="height: 30px;
                          width: 43px;
        font-size: 32px;
        color: #4285F4;" data-id="${editId}">share</i>
        <div class="chat-log__item chat-log__item--own">
            <div class="chat-log__message">
                ${queryValue}
            </div>
        </div>
    </div>

          <div class="clearfix"></div>
          <div class="chat-log__item loading-chat-bar" style="position: relative; z-index: 1000;">
              ${renderHelixLoaderTemplate('Loading graph')}
          </div>
          <div class="clearfix"></div>
          `;
}

function renderChatFelixTemplate(errorMessage) {
  return `<div class="chat-log__item">
        <div class="chat-log__message">
          ${errorMessage}
      </div>
    </div><div class="clearfix"></div>`;
}

function getChatTemplate(graphId) {
  return `<div class="chat-felix-chart">
            <main id="${graphId}graph-target">
            </main>
            <header class="chat-header">
              <div class="chat-header-main">
                <span class="material-icons graph-control-btn panel-hide-button" title="Show/hide edits" aria-label="Show/hide edits">expand_more</span>
                <form class="askfelixformeditchat" action="/edit-graph" data-gtm-form-interact-id="0" data-id="${graphId}">
                    <div class="speech-input-row">
                        <button id="askfelixbuttonedit"
                                type="submit"
                                class="askfelixbutton search-button mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-js-ripple-effect">
                            <span class="material-icons md-64">edit</span>
                        </button>
                        <div class="next-message-slot"></div>
                        <input id="editchatquery"
                               class="typeahead tt-input"
                               type="text"
                               placeholder="Edit"
                               autofocus>
                        <input id="felix-secret"
                               class="felix-secret"
                               type="hidden"
                               name="secret"
                               value="">
                    </div>
                    <div class="speech-controls-row">
                        <button type="button"
                                class="mic-talk mdl-button mdl-js-button mdl-button--mini-fab mdl-js-ripple-effect">
                            <span class="material-icons highlighted-icon">mic</span>
                        </button>
                    </div>
                </form>
              </div>
              <div class="chat-edit-container">
              </div>
                
                <span class="card--title">
                </span>
              <span class="right">
  <!-- material bin icon/delete -->
  <!--                      retry button, hide/show button, change data source, change data vis type -->
  <!--                                          <span class="material-icons graph-control-btn" id="panel-delete-button">-->
  <!--                                              delete-->
  <!--                                          </span>-->
              
              </span>
            </header>
        </div>`;
}

function getChatEditTemplate(graphId) {
  return `<div class="chat-felix-chart">
                <main id="${graphId}graph-target" class="${graphId}graph-target">
                </main>
            
        </div>`;
}

function renderGraphTemplate(graphId) {
  return `<div class="grid-stack-item">
            <div class="grid-stack-item-content card__success">
                <header class="draggable-header">
                  <input type="checkbox" class="panel-select-checkbox" data-id="${graphId}" title="Select this chart" aria-label="Select chart">
                  <form class="askfelixformedit" action="/edit-graph" data-gtm-form-interact-id="0" data-id="${graphId}">
                      <div class="speech-input-row">
                          <button id="askfelixbuttonedit"
                                  type="submit"
                                  class="askfelixbutton search-button mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-js-ripple-effect">
                              <span class="material-icons md-64">edit</span>
                          </button>
                          <div class="next-message-slot" style="display:inline-block; vertical-align:middle; margin-right:8px"></div>
                          <input id="editquery"
                                 class="typeahead tt-input"
                                 type="text"
                                 placeholder="Edit"
                                 autofocus>
                          <input id="felix-secret"
                                 class="felix-secret"
                                 type="hidden"
                                 name="secret"
                                 value="">
                      </div>
                      <div class="speech-controls-row">
                          <button type="button"
                                  class="mic-talk mdl-button mdl-js-button mdl-button--mini-fab mdl-js-ripple-effect">
                              <span class="material-icons highlighted-icon">mic</span>
                          </button>
                      </div>
                  </form>
                    
                    <span class="card--title">
                    </span>
                  <span class="right">
  <!-- material bin icon/delete -->
                      <span class="material-icons graph-control-btn" id="panel-delete-button">
                          delete
                      </span>
                  
                      <span class="material-icons graph-control-btn panel-refresh-button">
                          refresh
                      </span>
                      <span class="material-icons graph-control-btn panel-retry-button" data-id="${graphId}">
                          replay
                      </span>
                      <span class="material-icons graph-control-btn panel-share-button" data-id="${graphId}">
                          share
                      </span>
                      <span class="material-icons graph-control-btn panel-edit-options-button" data-id="${graphId}">
                          tune
                      </span>
                      <span class="material-icons graph-control-btn panel-fullscreen-button" data-id="${graphId}" title="Toggle fullscreen">
                          fullscreen
                      </span>
                      <span class="material-icons graph-control-btn panel-copy-png-button" data-id="${graphId}" title="Copy chart as PNG">image</span>
                      <span class="material-icons graph-control-btn panel-download-csv-button" data-id="${graphId}" title="Download data as CSV">file_download</span>
                      <span class="material-icons graph-control-btn panel-rename-button" data-id="${graphId}" title="Name this chart">bookmark_add</span>
                  </span>
                </header>
                <main id="${graphId}graph-target">
                </main>
            </div>
        </div>`;
}

function renderGraphEditOptionsTemplate(graphId, metadata, columns = []) {
  // Default chart types available for selection
  const chartTypes = [
    { value: 'bar', label: 'Bar Chart' },
    { value: 'line', label: 'Line Chart' },
    { value: 'scatter', label: 'Scatter Plot' },
    { value: 'pie', label: 'Pie Chart' },
    { value: 'histogram', label: 'Histogram' },
    { value: 'box', label: 'Box Plot' },
    { value: 'heatmap', label: 'Heatmap' },
    { value: 'table', label: 'Table' }
  ];

  // Get current chart type from metadata
  const currentChartType = metadata && metadata.graph_type ? metadata.graph_type : 'scatter';

  // Create chart type options
  const chartTypeOptions = chartTypes.map(type => {
    const selected = type.value === currentChartType ? 'selected' : '';
    return `<option value="${type.value}" ${selected}>${type.label}</option>`;
  }).join('');

  // Create column options
  const columnOptions = columns.map(column => {
    return `<option value="${column}">${column}</option>`;
  }).join('');

  return `
    <div class="graph-edit-options-container" id="${graphId}-edit-options" style="display: none;">
      <div class="graph-edit-options-header">
        <span>Edit Graph Options</span>
        <button class="graph-edit-close-button mdl-button mdl-js-button mdl-button--icon" data-graph-id="${graphId}">
          <i class="material-icons">close</i>
        </button>
      </div>
      <div class="graph-edit-options-content">
        <div class="graph-edit-option">
          <label for="${graphId}-chart-type">Chart Type:</label>
          <select id="${graphId}-chart-type" class="graph-chart-type-select" data-graph-id="${graphId}">
            ${chartTypeOptions}
          </select>
        </div>
        <div class="graph-edit-option">
          <label for="${graphId}-x-axis">X-Axis:</label>
          <select id="${graphId}-x-axis" class="graph-x-axis-select" data-graph-id="${graphId}">
            <option value="">Select Column</option>
            ${columnOptions}
          </select>
        </div>
        <div class="graph-edit-option">
          <label for="${graphId}-y-axis">Y-Axis:</label>
          <select id="${graphId}-y-axis" class="graph-y-axis-select" data-graph-id="${graphId}">
            <option value="">Select Column</option>
            ${columnOptions}
          </select>
        </div>
        <div class="graph-edit-option">
          <label for="${graphId}-color">Color By:</label>
          <select id="${graphId}-color" class="graph-color-select" data-graph-id="${graphId}">
            <option value="">None</option>
            ${columnOptions}
          </select>
        </div>
        <div class="graph-edit-actions">
          <button class="graph-edit-apply-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored" 
                  data-graph-id="${graphId}">
            Apply Changes
          </button>
        </div>
      </div>
    </div>
  `;
}

function renderPipelineLogsTemplate(logs, reasoningTrace = {}, judgeResult = null) {
  if (!logs || logs.length === 0) {
    return '';
  }

  const escapeHtml = value => {
    if (value === null || value === undefined) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  const logCount = Number.isFinite(reasoningTrace.log_count) ? reasoningTrace.log_count : logs.length;
  const highlights = Array.isArray(reasoningTrace.highlights) ? reasoningTrace.highlights : [];
  const fallbacks = Array.isArray(reasoningTrace.fallbacks) ? reasoningTrace.fallbacks : [];
  const datasetSummary = reasoningTrace.dataset && typeof reasoningTrace.dataset === 'object' ? reasoningTrace.dataset : {};
  const dataProcessingSummary = reasoningTrace.data_processing && typeof reasoningTrace.data_processing === 'object'
    ? reasoningTrace.data_processing
    : {};
  const graphSummary = reasoningTrace.graph && typeof reasoningTrace.graph === 'object' ? reasoningTrace.graph : {};
  const visualizationSummary = reasoningTrace.visualization && typeof reasoningTrace.visualization === 'object'
    ? reasoningTrace.visualization
    : {};

  const joinParts = parts => parts.filter(Boolean).map(escapeHtml).join(' · ');
  const formatOverviewRow = (label, parts) => {
    if (!parts || (Array.isArray(parts) && parts.length === 0)) {
      return '';
    }
    const value = Array.isArray(parts) ? joinParts(parts) : escapeHtml(parts);
    if (!value) {
      return '';
    }
    return `<div class="pipeline-logs-overview-row">
      <span class="pipeline-logs-overview-label">${escapeHtml(label)}</span>
      <span class="pipeline-logs-overview-value">${value}</span>
    </div>`;
  };

  const overviewSections = [];
  const datasetParts = [];
  if (datasetSummary.profile_label || datasetSummary.selected_file) {
    datasetParts.push(datasetSummary.profile_label || datasetSummary.selected_file);
  }
  if (Number.isFinite(datasetSummary.row_count) && Number.isFinite(datasetSummary.column_count)) {
    datasetParts.push(`${datasetSummary.row_count}×${datasetSummary.column_count}`);
  } else if (Number.isFinite(datasetSummary.row_count)) {
    datasetParts.push(`${datasetSummary.row_count} rows`);
  }
  if (Array.isArray(datasetSummary.columns_sample) && datasetSummary.columns_sample.length) {
    datasetParts.push(`cols: ${datasetSummary.columns_sample.slice(0, 4).join(', ')}`);
  }
  const datasetRow = formatOverviewRow('Dataset', datasetParts);
  if (datasetRow) overviewSections.push(datasetRow);

  const dataParts = [];
  if (dataProcessingSummary.query) {
    const preview = String(dataProcessingSummary.query);
    dataParts.push(preview.length > 80 ? `${preview.slice(0, 77)}…` : preview);
  }
  if (dataProcessingSummary.inline_data_used) {
    dataParts.push('inline data');
  }
  if (Array.isArray(dataProcessingSummary.additional_dataframes) && dataProcessingSummary.additional_dataframes.length) {
    dataParts.push(`extra frames: ${dataProcessingSummary.additional_dataframes.length}`);
  }
  if (dataProcessingSummary.filter_controls) {
    dataParts.push('filters');
  }
  const dataRow = formatOverviewRow('Data prep', dataParts);
  if (dataRow) overviewSections.push(dataRow);

  const graphParts = [];
  if (graphSummary.type) {
    graphParts.push(graphSummary.type);
  }
  if (graphSummary.override_source) {
    graphParts.push(`override: ${graphSummary.override_source}`);
  }
  if (graphSummary.arguments && typeof graphSummary.arguments === 'object') {
    const argKeys = Object.keys(graphSummary.arguments).slice(0, 4);
    if (argKeys.length) {
      graphParts.push(`args: ${argKeys.join(', ')}`);
    }
  }
  const graphRow = formatOverviewRow('Graph', graphParts);
  if (graphRow) overviewSections.push(graphRow);

  const vizParts = [];
  if (visualizationSummary.renderer) {
    vizParts.push(visualizationSummary.renderer);
  }
  if (visualizationSummary.template) {
    vizParts.push(`template ${visualizationSummary.template}`);
  }
  if (visualizationSummary.d3_disabled) {
    vizParts.push('plotly-only');
  }
  if (visualizationSummary.filter_controls) {
    vizParts.push('filters enabled');
  }
  const vizRow = formatOverviewRow('Display', vizParts);
  if (vizRow) overviewSections.push(vizRow);

  let summaryHtml = '';
  const overviewHtml = overviewSections.length > 0 ? `<div class="pipeline-logs-overview">${overviewSections.join('')}</div>` : '';
  if (highlights.length > 0 || fallbacks.length > 0 || judgeResult) {
    const highlightItems = highlights
      .map(item => `<li>${escapeHtml(item)}</li>`)
      .join('');

    let fallbackHtml = '';
    if (fallbacks.length > 0) {
      const fallbackItems = fallbacks
        .slice(-3)
        .map(fb => {
          const stage = escapeHtml(fb.stage || 'stage');
          const decision = escapeHtml(fb.decision || 'fallback');
          const recovered = fb.recovered ? 'resolved' : 'unresolved';
          return `<li><span class="pipeline-fallback-stage">${stage}</span> → ${decision} <span class="pipeline-fallback-status">${recovered}</span></li>`;
        })
        .join('');
      fallbackHtml = `
        <div class="pipeline-logs-fallbacks">
          <div class="pipeline-logs-summary-title">Fallbacks</div>
          <ul class="pipeline-fallback-list">${fallbackItems}</ul>
        </div>
      `;
    }

    let judgeHtml = '';
    if (judgeResult && typeof judgeResult === 'object') {
      const status = escapeHtml(judgeResult.status || 'unknown');
      const statusClass = status.toLowerCase().replace(/[^a-z0-9_-]/g, '-');
      const verdict = escapeHtml(judgeResult.verdict || status);
      const scoreValue =
        typeof judgeResult.score === 'number'
          ? `${Math.round(judgeResult.score * 100)}%`
          : '';
      const improvements = Array.isArray(judgeResult.improvements)
        ? judgeResult.improvements.filter(Boolean)
        : [];
      const improvementsHtml =
        improvements.length > 0
          ? `<ul class="pipeline-logs-judge-improvements">${improvements
              .map(item => `<li>${escapeHtml(item)}</li>`)
              .join('')}</ul>`
          : '';

      // Surface why the judge could not score the result. On error/skipped/
      // unavailable statuses the backend supplies a `reason`; an `invalid`
      // status carries the un-parseable `raw` response. Without this the panel
      // only showed "error" with no explanation.
      let reasonText = '';
      if (judgeResult.reason) {
        reasonText = String(judgeResult.reason);
      } else if (judgeResult.raw && typeof judgeResult.raw === 'string') {
        reasonText = judgeResult.raw;
      }
      const reasonHtml = reasonText
        ? `<div class="pipeline-logs-judge-reason">${escapeHtml(reasonText)}</div>`
        : '';

      judgeHtml = `
        <div class="pipeline-logs-judge pipeline-logs-judge--${statusClass}">
          <span class="pipeline-logs-judge-label">${verdict}</span>
          ${scoreValue ? `<span class="pipeline-logs-judge-score">${scoreValue}</span>` : ''}
          ${reasonHtml}
          ${improvementsHtml}
        </div>
      `;
    }

    summaryHtml = `
      <div class="pipeline-logs-summary">
        ${overviewHtml}
        ${highlights.length > 0 ? `<div class="pipeline-logs-summary-title">At a glance</div>` : ''}
        ${highlights.length > 0 ? `<ul class="pipeline-logs-summary-list">${highlightItems}</ul>` : ''}
        ${fallbackHtml}
        ${judgeHtml}
      </div>
    `;
  }

  const logItemsHtml = logs.map((log, index) => {
    const step = log.step || 'unknown';
    const message = log.message || '';
    const details = log.details || {};
    const codeExample = log.code_example || '';

    let codeHtml = '';
    if (codeExample) {
      codeHtml = `
        <div class="pipeline-log-code">
          <div class="pipeline-log-code-header">Code Example:</div>
          <pre><code class="python">${codeExample}</code></pre>
        </div>
      `;
    }

    let detailsHtml = '';
    if (Object.keys(details).length > 0) {
      detailsHtml = `
        <div class="pipeline-log-details">
          <div class="pipeline-log-details-header">Details:</div>
          <pre>${JSON.stringify(details, null, 2)}</pre>
        </div>
      `;
    }

    return `
      <div class="pipeline-log-item">
        <div class="pipeline-log-step">${step}</div>
        <div class="pipeline-log-message">${message}</div>
        ${codeHtml}
        ${detailsHtml}
      </div>
    `;
  }).join('');

  return `
    <div class="pipeline-logs-container" data-log-count="${logCount}">
      <div class="pipeline-logs-header">
        <span class="pipeline-logs-toggle">
          <i class="material-icons">psychology</i> Reasoning Trace
        </span>
        <div class="pipeline-logs-actions">
          <span class="pipeline-logs-count">${logCount} steps</span>
          <button class="copy-logs-button mdl-button mdl-js-button mdl-button--icon" title="Copy logs to clipboard">
            <i class="material-icons">content_copy</i>
          </button>
        </div>
      </div>
      <div class="pipeline-logs-content" style="display: none;">
        ${summaryHtml}
        ${logItemsHtml}
      </div>
    </div>
  `;
}

if (typeof window !== 'undefined') {
  window.renderHelixLoaderTemplate = renderHelixLoaderTemplate;
  window.renderChatMessageTemplate = renderChatMessageTemplate;
  window.renderChatFelixTemplate = renderChatFelixTemplate;
  window.getChatTemplate = getChatTemplate;
  window.getChatEditTemplate = getChatEditTemplate;
  window.renderGraphTemplate = renderGraphTemplate;
  window.renderGraphEditOptionsTemplate = renderGraphEditOptionsTemplate;
  window.renderPipelineLogsTemplate = renderPipelineLogsTemplate;
}
